import React from 'react';
import { TooltipKeys } from '../../tooltips/TooltipKeys';
import UINextStep  from '../subcomponents/UINextStep';
import UIPreviousStep  from '../subcomponents/UIPreviousStep';
import UIVoice  from '../subcomponents/UIVoice';
import UIOptions  from '../subcomponents/UIOptions';
import UIProjectOptions  from '../subcomponents/UIProjectOptions';
import subComponentTypes from '../subcomponents/types';
import UIEditorComponentRenderer from '../UIEditorComponentRenderer';

export default function TTitleMenu6(props)
{
	function getRawProperties()
	{
		return {
			[subComponentTypes.PROJECT_OPTIONS]:{ ...UIProjectOptions({ ...props, anchor:'top' }) },
			[subComponentTypes.OPTIONS]:{ ...UIOptions({ ...props, size:6, top:50, layout:'2 columns' }) },
			[subComponentTypes.NEXT_STEP]:{ ...UINextStep({ ...props }) },
			[subComponentTypes.PREVIOUS_STEP]:{ ...UIPreviousStep({ ...props }) },
			[subComponentTypes.VOICE]:{ ...UIVoice({ ...props }) }
		}
	}

	if(props.getProperties)
	{
		return getRawProperties();
	}

	function repackProperties()
	{
		let rawProperties = getRawProperties();
		// console.log(rawProperties);
		let flatProperties = [
			{
				type: 'group',
				key: 'project options group',
				title: rawProperties.ProjectOptions.props.title,
				subcomponent: null,
				decorator: {
					...rawProperties.ProjectOptions.props.properties['visible'],
					key: 'visible',
					type: 'toggle-icon',
					subcomponent: rawProperties.ProjectOptions.props.subcomponent,
					title: '',
				},
				children: [
					{
						...rawProperties.ProjectOptions.props.properties['scenario logo'],
						key: 'scenario logo',
						subcomponent: rawProperties.ProjectOptions.props.subcomponent,
						title: "Scenario Logo",
					},
					{
						...rawProperties.ProjectOptions.props.properties['company logo'],
						key: 'company logo',
						subcomponent: rawProperties.ProjectOptions.props.subcomponent,
						title: "Company Logo",
					},
					{
						...rawProperties.ProjectOptions.props.properties.title,
						key: 'title',
						subcomponent: rawProperties.ProjectOptions.props.subcomponent,
						title: "",
					},
					{
						type: 'color-alpha',
						title: "Title",
						color: {
							...rawProperties.ProjectOptions.props.properties['title color'],
							key: 'title color',
							subcomponent: rawProperties.ProjectOptions.props.subcomponent,
						},
						alpha: {
							...rawProperties.ProjectOptions.props.properties['title alpha'],
							key: 'title alpha',
							subcomponent: rawProperties.ProjectOptions.props.subcomponent,
						},
					},
					{
						...rawProperties.ProjectOptions.props.properties.subtitle,
						key: 'subtitle',
						subcomponent: rawProperties.ProjectOptions.props.subcomponent,
						title: "",
					},
					{
						type: 'color-alpha',
						title: "Subtitle",
						color: {
							...rawProperties.ProjectOptions.props.properties['subtitle color'],
							key: 'subtitle color',
							subcomponent: rawProperties.ProjectOptions.props.subcomponent,
						},
						alpha: {
							...rawProperties.ProjectOptions.props.properties['subtitle alpha'],
							key: 'subtitle alpha',
							subcomponent: rawProperties.ProjectOptions.props.subcomponent,
						},
					},
					{
						type: 'color-alpha',
						title: "Background",
						color: {
							...rawProperties.ProjectOptions.props.properties['background color'],
							key: 'background color',
							subcomponent: rawProperties.ProjectOptions.props.subcomponent,
						},
						alpha: {
							...rawProperties.ProjectOptions.props.properties['background alpha'],
							key: 'background alpha',
							subcomponent: rawProperties.ProjectOptions.props.subcomponent,
						},
					},
					{
						...rawProperties.ProjectOptions.props.properties['anchor'],
						key: 'anchor',
						subcomponent: rawProperties.ProjectOptions.props.subcomponent,
						title: "Anchor",
					},
				]
			},
			{
				type: 'group',
				key: 'options group',
				title: rawProperties.Options.props.title,
				subcomponent: null,
				decorator: {
					...rawProperties.Options.props.properties['visible'],
					key: 'visible',
					type: 'toggle-icon',
					subcomponent: rawProperties.Options.props.subcomponent,
					title: '',
				},
				children: [
					{
						...rawProperties.Options.props.properties['layout'],
						key: 'layout',
						subcomponent: rawProperties.Options.props.subcomponent,
						title: 'Layout',
					},
					{
						...rawProperties.Options.props.properties['option spacing'],
						key: 'option spacing',
						subcomponent: rawProperties.Options.props.subcomponent,
						title: 'Spacing',
					},
					{
						...rawProperties.Options.props.properties['option top padding'],
						key: 'option top padding',
						subcomponent: rawProperties.Options.props.subcomponent,
						title: 'Top padding',
					},
				].concat((()=>
				{
					let generatedOptions = [];
					let optionCounter = 1;
					while(rawProperties.Options.props.properties[`option ${optionCounter} text`])
					{
						generatedOptions.push({
							type: 'group',
							key: `option ${optionCounter} group`,
							collapsed: true,
							title: `Option ${optionCounter}`,
							titleAddon: {
								key: `option ${optionCounter} text`,
								subcomponent: rawProperties.Options.props.subcomponent
							},
							subcomponent: null,
							decorator: {
								...rawProperties.Options.props.properties[`option ${optionCounter} visible`],
								key: `option ${optionCounter} visible`,
								type: 'toggle-icon',
								subcomponent: rawProperties.Options.props.subcomponent,
								title: '',
							},
							children: [
								{
									...rawProperties.Options.props.properties[`option ${optionCounter} text`],
									key: `option ${optionCounter} text`,
									subcomponent: rawProperties.Options.props.subcomponent,
									title: "",
								},
								{
									type: 'color-alpha',
									title: "Text",
									color: {
										...rawProperties.Options.props.properties[`option ${optionCounter} text color`],
										key: `option ${optionCounter} text color`,
										subcomponent: rawProperties.Options.props.subcomponent,
									},
									alpha: {
										...rawProperties.Options.props.properties[`option ${optionCounter} text alpha`],
										key: `option ${optionCounter} text alpha`,
										subcomponent: rawProperties.Options.props.subcomponent,
									},
								},
								{
									type: 'color-alpha',
									title: "Background",
									color: {
										...rawProperties.Options.props.properties[`option ${optionCounter} background color`],
										key: `option ${optionCounter} background color`,
										subcomponent: rawProperties.Options.props.subcomponent,
									},
									alpha: {
										...rawProperties.Options.props.properties[`option ${optionCounter} background alpha`],
										key: `option ${optionCounter} background alpha`,
										subcomponent: rawProperties.Options.props.subcomponent,
									},
								},
								{
									type: 'color-alpha',
									title: "Stroke",
									color: {
										...rawProperties.Options.props.properties[`option ${optionCounter} shadow color`],
										key: `option ${optionCounter} shadow color`,
										subcomponent: rawProperties.Options.props.subcomponent,
									},
									alpha: {
										...rawProperties.Options.props.properties[`option ${optionCounter} shadow alpha`],
										key: `option ${optionCounter} shadow alpha`,
										subcomponent: rawProperties.Options.props.subcomponent,
									},
								},
								{
									...rawProperties.Options.props.properties[`option ${optionCounter} link`],
									key: `option ${optionCounter} link`,
									subcomponent: rawProperties.Options.props.subcomponent,
									title: "Target",
								},
							]
						})
						optionCounter++;
					}
					return generatedOptions;
				})())
			},
			{
				...rawProperties.NextStep.props.properties.visible,
				key: 'visible',
				subcomponent: rawProperties.NextStep.props.subcomponent,
				title: rawProperties.NextStep.props.title,
			},
			{
				...rawProperties.PreviousStep.props.properties.visible,
				key: 'visible',
				subcomponent: rawProperties.PreviousStep.props.subcomponent,
				title: rawProperties.PreviousStep.props.title,
			},
			{
				type: 'group',
				key: 'voice group',
				tooltip: TooltipKeys.UIVoice,
				title: rawProperties.Voice.props.title,
				subcomponent: null,
				children: [
					{
						...rawProperties.Voice.props.properties.Voice,
						key: 'Voice',
						subcomponent: rawProperties.Voice.props.subcomponent,
						title: "",
					}
				]

                
			},
		]
		return <UIEditorComponentRenderer
			{...props}
			properties={flatProperties}
		/>;
	}

	return (
		props.context === 'editor' ? 
			<>
				{repackProperties()}
			</>
			:
			<>
				<UIProjectOptions {...props} anchor={'top'} />
				<UIOptions {...props} size={6} top={50} layout={'2 columns'} />
				<UINextStep {...props} />
				<UIPreviousStep {...props} />
				<UIVoice {...props} />
			</>
	);
}